import React from 'react';

const getPrice = (item) => {
    if (item.type === 'multiroom') return  0;
    if (item.price) return item.price.price;
}

const ProductSelectorItem = ({ item }) => <div className="selector-item clearfix">
    {item.image && <img src={item.image} className="image pull-left"/>}
    <b> {item.name}</b> - {getPrice(item)},- &nbsp; 
    {item.label && <div>{item.label}</div>}
</div>

export default ProductSelectorItem;